import React from 'react';
import PropTypes from 'prop-types';
import css from './Sections.module.css';
import { Icons } from '../../../components';
import classNames from 'classnames';

function SectionPayment({ intl }) {
  return (
    <div className={css.paymentContainer}>
      <div className={css.fixedWidthContainer}>
        <div className={css.featuresContent}>
          <h2>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.securePayments.title' })}</h2>
          <p>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.securePayments.description' })}</p>
          <div className={css.paymentMethods}>
            <div className={css.paymentIcon}>
              <Icons name="applePay" />
            </div>
            <div className={css.paymentIcon}>
              <Icons name="googlePay" />
            </div>
            <div className={css.paymentIcon}>
              <Icons name="paypal" />
            </div>
            <div className={css.paymentIcon}>
              <Icons name="cardPay" />
            </div>
          </div>
        </div>

        <div className={css.featuresContent}>
          <h2>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.easyReturns.title' })}</h2>
          <p>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.easyReturns.description' })}</p>
        </div>
        <div className={css.protectionTypeSec}>
          <div className={css.protectionTypeBlock}>
            <h2>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.whatYoureProtectedFrom.title' })}</h2>
            <div className={css.protectionContent}>
              <div className={css.protectionType}>
                {intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.whatYoureProtectedFrom.item1' })}
              </div>
              <div className={css.protectionType}>
                {intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.whatYoureProtectedFrom.item2' })}
              </div>
              <div className={css.protectionType}>
                {intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.whatYoureProtectedFrom.item3' })}
              </div>
              <div className={css.protectionType}>
                {intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.whatYoureProtectedFrom.item4' })}
              </div>
              <div className={css.protectionType}>
                {intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.whatYoureProtectedFrom.item5' })}
              </div>
            </div>
          </div>
          <div className={css.protectionTypeBlock}>
            <h2>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.yourProtectionInAction.title' })}</h2>
            <div className={css.protectionContent}>
              <div className={css.protectionType}>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.yourProtectionInAction.step1' })}</div>
              <Icons name="downPointer" />
              <div className={css.protectionType}>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.yourProtectionInAction.step2' })}</div>
              <Icons name="downPointer" />
              <div className={css.protectionType}>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.yourProtectionInAction.step3' })}</div>
              <Icons name="downPointer" />
              <div className={css.protectionType}>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.yourProtectionInAction.step4' })}</div>
              <Icons name="downPointer" />
              <div className={css.protectionType}>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.yourProtectionInAction.step5' })}</div>
              <Icons name="downPointer" />
              <div className={css.protectionType}>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.yourProtectionInAction.step6' })}</div>
            </div>
          </div>
        </div>

        <div className={classNames(css.featuresContent, css.communitySafety)}>
          <h2>
            {intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.communitySafety.title' })} <br />
            <span>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.communitySafety.subtitle' })}</span>
          </h2>
          <div className={css.paymentSafetySec}>
            <div className={css.safetyBlock}>
              <h2>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.communitySafety.escrowPayments.title' })}</h2>
              <p>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.communitySafety.escrowPayments.description' })}</p>
            </div>

            <div className={css.safetyBlock}>
              <h2>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.communitySafety.dailyListingChecks.title' })}</h2>
              <p>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.communitySafety.dailyListingChecks.description' })}</p>
            </div>

            <div className={css.safetyBlock}>
              <h2>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.communitySafety.disputeSupport.title' })}</h2>
              <p>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionPayment.communitySafety.disputeSupport.description' })}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionPayment;